<template>
  <div id="dashboard" class="content">
    <div class="row">
      <div class="col-12">
        <a class="block block-rounded" href="javascript:void(0)">
          <div class="block-header block-header-default">
            <h3 class="block-title">总充电时长</h3>
          </div>
          <div class="block-content block-content-full">
            <div class="row text-center">
              <div class="col-12"></div>
              <div class="col-4">
                <div class="py-0">
                  <p
                    class="font-size-125 font-w300 mb-0"
                  >{{ (stats && stats.yesterdayChargeHour+'') || '--'}}</p>
                  <p class="text-muted mb-0 font-size-75">{{duration.startDate}}</p>
                </div>
              </div>
              <div class="col-4">
                <div class="py-0">
                  <p
                    class="font-size-125 font-w300 mb-0"
                  >{{(stats && stats.sumChargeHour+'') || '--'}}</p>
                  <p class="text-muted mb-0 font-size-75">{{duration.label}}</p>
                </div>
              </div>
              <div class="col-4">
                <div class="py-0">
                  <p
                    class="font-size-125 font-w300 mb-0"
                    v-html="(stats && compare(stats.seqChargeHour)+'') || '--'"
                  ></p>
                  <p class="text-muted mb-0 font-size-75">环比</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div id="chart-degree" style="width: 100%; height: 200px"></div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-12" style="margin-bottom: 10px;">
      <div class="row mb-2 mt-4" style="margin-right: -64px;">
        <div class="col-6 row">
          <h2 class="h3 font-w400 mb-0 line-height">{{localSelect}}充电时长数据</h2>
        </div>
        <div class="col-6 text-right mr-0">
          <screenTime :isToday="'1'" @changePage="changePage"></screenTime>
        </div>
      </div>
    </div>
    <div class="block block-rounded block-bordered">
      <div class="block-header block-header-default">
        <h3 class="block-title">{{ '时间范围： ' + duration.startDate + ' 至 ' + this.duration.endDate }}</h3>
        <div class="block-options">
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
      </div>
      <div class="block-content block-content-full">
        <div class="dataTables_wrapper dt-bootstrap4 no-footer">
          <div class="row mb-1">
            <div class="col-12 col-md-4 text-center text-md-left">
              <pageSize @changePageSize="changePageSize"></pageSize>
            </div>
            <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
              <div class="dt-buttons">
                <button
                  class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                  tabindex="0"
                  aria-controls="DataTables_Table_1"
                  data-clipboard-text
                  @click="copy()"
                  type="button"
                  id="copybtn"
                >
                  <span>复制</span>
                </button>
                <button
                  class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                  @click="exportCSV()"
                  type="button"
                >
                  <span>导出</span>
                </button>
                <button
                  class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                  @click="print()"
                >
                  <span>打印</span>
                </button>
              </div>
            </div>
            <div class="col-12 col-md-4 text-center text-md-right">
              <div class="dataTables_filter">
                <label>
                  <input
                    type="search"
                    class="form-control"
                    placeholder="搜索"
                    v-model="key"
                    @keyup.enter="search()"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="table-responsive">
                <section ref="print">
                  <p class="show-on-print print-title">{{localSelect}}充电时长数据</p>
                  <p
                    class="show-on-print print-subheading"
                  >{{ '时间范围： ' + duration.startDate + ' 至 ' + this.duration.endDate }}</p>
                  <table
                    class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                  >
                    <thead>
                      <tr>
                        <th
                          class="text-center sorting"
                          style="width: 60px; min-width:60px"
                          @click="getList('PROVINCE',$event)"
                        >#</th>
                        <th
                          class="text-left sorting"
                          style=" min-width:130px;"
                          @click="getList('PROVINCE',$event)"
                        >省份</th>
                        <th
                          class="text-left sorting"
                          style=" min-width:100px;"
                          @click="getList('CITY',$event)"
                          v-if="regionParams.region!='all'"
                        >城市</th>
                        <th
                          class="text-left sorting"
                          style="width:120px;min-width:120px;"
                          @click="getList('DISTRICT',$event)"
                          v-if="regionParams.region=='city'||regionParams.region=='district'"
                        >区域</th>
                        <th
                          class="text-left sorting"
                          style="min-width:110px;"
                          @click="getList('CELL_COUNT',$event)"
                          v-if="regionParams.region!='district'"
                        >小区数量</th>
                        <th
                          class="text-left sorting"
                          style=" min-width:150px;"
                          @click="getList('CELL_NAME',$event)"
                          v-if="regionParams.region=='district'"
                        >小区名称</th>
                        <th
                          class="text-left sorting"
                          style=" min-width:100px;"
                          @click="getList('PORT_NUM',$event)"
                        >端口数量</th>
                        <th
                          class="text-left sorting"
                          style=" min-width:110px;"
                          @click="getList('ARPU_FEE',$event)"
                        >端口ARPU</th>
                        <th
                          class="text-left sorting"
                          style=" min-width:110px;"
                          @click="getList('ORDER_NUM ',$event)"
                        >总充电次数</th>
                        <th
                          class="text-left sorting"
                          style=" min-width:115px;"
                          @click="getList('CHARGE_TOTAL_HOUR',$event)"
                        >总充电时长</th>
                        <th
                          class="text-left sorting"
                          style=" min-width:160px;"
                          @click="getList('AVG_ORDER_NUM',$event)"
                        >日均充电次数</th>
                        <th
                          class="text-left sorting"
                          style=" min-width:160px;"
                          @click="getList('AVG_CHARGE_TOTAL_HOUR',$event)"
                        >日均充电时长</th>
                        <th
                          class="text-left sorting"
                          style=" min-width:100px;"
                          @click="getList('UNIFIED_CONSUME_POWER',$event)"
                        >总用电量</th>
                        <th
                          class="text-left sorting"
                          style=" min-width:100px;"
                          @click="getList('BIS_NAME',$event)"
                        >结算模式</th>
                        <th
                          class="text-left sorting"
                          style=" min-width:100px;"
                          @click="getList('ELECTRICITY_RATE',$event)"
                        >结算电价</th>
                        <th
                          class="text-left sorting"
                          style=" min-width:100px;"
                          @click="getList('ELECTRICITY_RATE_TOTAL',$event)"
                        >用电成本</th>
                        <!-- <th
                          class="text-left sorting"
                          style="width:180px;min-width:180px;"
                          @click="getList('AGV_CHARGE',$event)"
                        >总人均充电时长(小时)</th>-->
                        <th
                          class="text-center d-xl-table-cell"
                          style="min-width:100px;"
                          v-if="isAllCell"
                        >操作</th>
                      </tr>
                    </thead>
                    <tbody v-if="chargeHourList.length">
                      <tr v-for="(item, i) in chargeHourList" :key="i">
                        <td class="text-center">{{ i + 1 }}</td>
                        <td class="text-left">{{ item.PROVINCE }}</td>
                        <td
                          class="text-left d-md-table-cell"
                          v-if="regionParams.region!='all'"
                        >{{ item.CITY }}</td>
                        <td
                          class="text-left d-md-table-cell"
                          v-if="regionParams.region=='city'||regionParams.region=='district'"
                        >{{ item.DISTRICT }}</td>
                        <td
                          class="text-left d-md-table-cell"
                          v-if="regionParams.region!='district'"
                        >{{ item.CELL_COUNT }}</td>
                        <td
                          class="text-left d-md-table-cell"
                          v-if="regionParams.region=='district'"
                        >{{ item.CELL_NAME }}</td>
                        <td class="text-left" style="width:150px">{{ item.PORT_NUM }}</td>
                        <td
                          class="text-left"
                          style="width:150px"
                        >{{ changeTwoDecimal(item.ARPU_FEE) }}</td>
                        <td class="text-left" style="width:150px">{{ item.ORDER_NUM }}</td>
                        <td
                          class="text-left"
                          style="width:150px"
                        >{{ changeTwoDecimal(item.CHARGE_TOTAL_HOUR) }}</td>
                        <td
                          class="text-left"
                          style="width:150px"
                        >{{ changeTwoDecimal(item.AVG_ORDER_NUM) }}</td>
                        <td
                          class="text-left"
                          style="width:150px"
                        >{{ changeTwoDecimal(item.AVG_CHARGE_TOTAL_HOUR) }}</td>

                        <td
                          class="text-left d-md-table-cell"
                        >{{ changeTwoDecimal(item.UNIFIED_CONSUME_POWER) }}</td>
                        <td class="text-left d-md-table-cell">{{ item.BIS_NAME }}</td>
                        <td
                          class="text-left"
                          style="width:150px"
                        >{{ changeTwoDecimal(item.ELECTRICITY_RATE) }}</td>
                        <td
                          class="text-left"
                          style="width:150px"
                        >{{ changeTwoDecimal(item.ELECTRICITY_RATE_TOTAL) }}</td>
                        <!-- <td
                          class="text-left"
                          style="width:150px"
                        >{{ changeTwoDecimal(item.AGV_CHARGE) }}</td>-->
                        <td class="text-center d-xl-table-cell" v-if="isAllCell">
                          <button
                            type="button"
                            class="btn btn-primary"
                            title="查看"
                            data-original-title="Edit"
                            data-toggle="modal"
                            @click="go(item)"
                          >
                            <i class="fa fa-search"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td class="text-center" colspan="17">查无数据</td>
                      </tr>
                    </tbody>
                  </table>
                </section>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
              <div class="dataTables_info" role="status" aria-live="polite">
                页数
                <strong>{{ page }}</strong> /
                <strong>{{ totalPage }}</strong>
              </div>
            </div>
            <div class="col-sm-12 col-md-7 text-center text-md-right">
              <div class="dataTables_paginate paging_full_numbers">
                <el-pagination
                  v-if="chargeHourList && chargeHourList.length"
                  @current-change="handleCurrentChange"
                  :current-page="page"
                  :page-size="pageSize"
                  :pager-count="pagerCount"
                  :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                  :small="isMobile"
                  :total="total"
                  background
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 引入基本模板
let echarts = require("echarts/lib/echarts");
// 引入柱状图组件
require("echarts/lib/chart/pie");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/line");
require("echarts/lib/chart/map");
import Util from "../../../../Util.js";
import screenTime from "../../../../components/screenTime";
import pageSize from "../../../../components/pageSize";

export default {
  name: "index",
  data() {
    return {
      chargeHourList: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      clipboard: null,
      sorting: "",
      orderBy: false,
      totalList: [],
      agents: [],
      stats: null,
      charts: [],
      entryUrl: "",
      url: "",
      listUrl: ""
    };
  },
  components: {
    screenTime,
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    regionParams() {
      return this.$store.state.regionParams;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    params() {
      return this.$store.state.params;
    },
    localSelect() {
      return this.$store.state.localSelect;
    },
    isAllCell() {
      return this.$store.state.isAllCell;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
          this.getEchart();
        }
      },
      immediate: true,
      deep: true
    },

    key(val, oldVal) {
      if (val.length == 0) {
        this.getList();
      }
    }
  },
  mounted() {
    if (this.$route.params.type) {
      this.$store.commit("setParam", {
        params: this.$route.params
      });
    }
    // 列表
    this.listUrl = Util.getDifferentRolesUrl(
      this,
      "CarportStat/ListByChargeHourByCity"
    );
    // 折线图,不同身份获取基本数据的接口
    this.entryUrl = Util.getDifferentRolesUrl(
      this,
      "CarportStat/Query",
      this.params.id
    );
    let that = this;
    window.onresize = function() {
      setTimeout(_ => {
        that.resizeCharts();
      }, 500);
    };
    // this.getEntry()
    this.getList();
    this.copy();
    this.getEchart();
  },
  methods: {
    go(val) {
      let text, name, url, num;
      if (this.regionParams.region == "all") {
        text = "province";
        name = val.PROVINCE;
        url = "City/ListByProvince";
        num = 2;
      } else if (this.regionParams.region == "province") {
        text = "city";
        name = val.CITY;
        url = "District/ListByCity";
        num = 3;
      } else if (this.regionParams.region == "city") {
        text = "district";
        name = val.DISTRICT;
        url = "FlatComplex/ListByDistrict";
        num = 4;
      } else if (this.regionParams.region == "district") {
        text = "flatComplex";
        name = val.CELL_NAME;
        url = "FlatComplex/ListByDistrict";
        num = 4;
      }
      this.$store.commit("setParam", {
        returnKey: true,
        regionParams: {
          region: text, //all,province,city,district,flatComplex,pile , 默认是all
          object: val.TARGET_ID
        },
        localSelect: name
      });
      if (this.regionParams.region == "flatComplex") {
        this.$router.push({
          name: "cellDurationList",
          params: {
            id: val.TARGET_ID
          }
        });
      } else {
        this.$store.commit("setParam", {
          menuTitle: name
        });
        this.chargeHourList = [];
        this.getList();
        this.getEchart();
        this.getMenuData(url, val.TARGET_ID, num);
      }
    },
    getMenuData(url, id, num) {
      this.$http.get(`${Util.searchURL}/${url}/${id}?isMenu=true`).then(
        result => {
          if (result.data.code === 200) {
            let data = result.data.data;
            for (let i of data) {
              i.type = num;
            }
            this.$store.commit("setParam", {
              menu: data,
              fullscreenLoading: false
            });
          }
        },
        err => {
          this.$store.commit("setParam", {
            fullscreenLoading: false
          });
          console.log(err);
        }
      );
    },
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    changePage(val) {
      this.page = val;
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    compare: val => {
      let modifier = val > 0 ? "+ " : "";
      let color = val > 0 ? "green" : "red;";
      return `<div style="color: ${color}">${modifier}${val}${
        val == "-" ? "" : "%"
      }</div>`;
    },
    resizeCharts() {
      for (let i = 0; i < this.charts.length; i++) {
        const chart = this.charts[i];
        chart.resize();
      }
    },
    selectVal(ele) {
      this.selected = ele.target.value;
    },
    getEchart() {
      this.$http
        .get(
          `${this.entryUrl}${this.duration.startDate}/${this.duration.endDate}?region=${this.regionParams.region}&object=${this.regionParams.object}`
        )
        .then(result => {
          if (result.data.data) {
            this.stats = result.data.data;
            $(function() {
              Dashmix.helpers([
                "easy-pie-chart",
                "sparkline",
                "datepicker",
                "flatpickr"
              ]);
            });
            $(".js-dataTable-buttons").DataTable();
            $(".js-dataTable-buttons")
              .DataTable()
              .clear();
            const dates = _.map(this.stats.log, x => x.statistics_date);
            setTimeout(() => {
              Util.initChart(
                this,
                "chart-degree",
                dates,
                _.map(this.stats.log, x => x.chargeHour),
                "#FFB119",
                "line",
                "小时"
              );
            }, 500);
          }
        });
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }

      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }
      this.$http
        .get(
          `${this.listUrl}${this.duration.startDate}/${this.duration.endDate}/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.chargeHourList = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    search() {
      this.page = 1;
      this.getList();
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      params["sort"] = this.sorting;
      params["orderBy"] = this.orderBy;
      this.$http
        .get(
          `${this.listUrl}${this.duration.startDate}/${this.duration.endDate}/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[0].innerText;
      var btn = document.getElementById("copybtn");
      btn.setAttribute("data-clipboard-text", copyStr);
      var clipboard = new ClipboardJS(btn);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();

        e.clearSelection();
      });
    }
  }
};
</script>
<style scoped lang="less">
.badge {
  font-weight: 400 !important;
}
.custom-control-inline {
  margin-right: 3rem;
}
.custom-control {
  label {
    font-size: 0.9375rem;
    font-weight: 400;
  }
}
</style>